/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cover_Letters_DeleteInputs */

const en_cover_letters_delete = /** @type {(inputs: Cover_Letters_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete`)
};

const de_cover_letters_delete = /** @type {(inputs: Cover_Letters_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Löschen`)
};

const fr_cover_letters_delete = /** @type {(inputs: Cover_Letters_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer`)
};

const es_cover_letters_delete = /** @type {(inputs: Cover_Letters_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar`)
};

const it_cover_letters_delete = /** @type {(inputs: Cover_Letters_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elimina`)
};

const nl_cover_letters_delete = /** @type {(inputs: Cover_Letters_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwijderen`)
};

const pl_cover_letters_delete = /** @type {(inputs: Cover_Letters_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usuń`)
};

const fi_cover_letters_delete = /** @type {(inputs: Cover_Letters_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poista`)
};

const da_cover_letters_delete = /** @type {(inputs: Cover_Letters_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slet`)
};

const sv_cover_letters_delete = /** @type {(inputs: Cover_Letters_DeleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Radera`)
};

/**
* | output |
* | --- |
* | "Delete" |
*
* @param {Cover_Letters_DeleteInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const cover_letters_delete = /** @type {((inputs?: Cover_Letters_DeleteInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cover_Letters_DeleteInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cover_letters_delete(inputs)
	if (locale === "fr") return fr_cover_letters_delete(inputs)
	if (locale === "es") return es_cover_letters_delete(inputs)
	if (locale === "it") return it_cover_letters_delete(inputs)
	if (locale === "nl") return nl_cover_letters_delete(inputs)
	if (locale === "pl") return pl_cover_letters_delete(inputs)
	if (locale === "fi") return fi_cover_letters_delete(inputs)
	if (locale === "da") return da_cover_letters_delete(inputs)
	if (locale === "sv") return sv_cover_letters_delete(inputs)
	return en_cover_letters_delete(inputs)
});